import { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import Logo from "../Logo";

const STORAGE_KEY = "nubevape_age_verified";

export default function AgeGate() {
  const [open, setOpen] = useState(false);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setOpen(true);
  }, []);

  if (!open) return null;

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  return (
    <div
      data-testid="age-verification-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#16181D]/90 backdrop-blur-md px-4"
    >
      <div className="w-full max-w-md rounded-2xl border border-[#2D323E] bg-[#1E2128] p-8 text-center shadow-[0_20px_60px_-15px_rgba(0,0,0,0.7)] animate-fade-up">
        <div className="flex justify-center mb-6">
          <Logo />
        </div>
        {denied ? (
          <>
            <ShieldAlert className="w-10 h-10 text-[#EF4444] mx-auto mb-4" />
            <h2 className="font-heading text-xl font-bold mb-2">Acceso restringido</h2>
            <p className="text-[#8A8F98] text-sm leading-relaxed">
              Esta tienda está reservada a mayores de 18 años. No podemos darte acceso al contenido.
            </p>
          </>
        ) : (
          <>
            <div className="mx-auto mb-5 w-16 h-16 rounded-full flex items-center justify-center bg-gradient-to-r from-[#2EE6D6] to-[#7C5CFF] text-black font-heading font-extrabold text-xl">
              +18
            </div>
            <h2 className="font-heading text-2xl font-bold mb-3">Verificación de edad</h2>
            <p className="text-[#8A8F98] text-sm leading-relaxed mb-2">
              Esta web vende productos de vapeo que pueden contener nicotina. La nicotina es una
              sustancia adictiva.
            </p>
            <p className="text-[#8A8F98] text-sm leading-relaxed mb-7">
              Debes ser mayor de 18 años para acceder, conforme a la normativa vigente en España.
            </p>
            <div className="flex flex-col gap-3">
              <button
                data-testid="age-verify-accept-btn"
                onClick={accept}
                className="w-full rounded-xl bg-gradient-to-r from-[#2EE6D6] to-[#7C5CFF] py-3 font-bold text-black shadow-[0_0_20px_rgba(46,230,214,0.3)] transition-opacity hover:opacity-90"
              >
                Soy mayor de 18 años
              </button>
              <button
                data-testid="age-verify-deny-btn"
                onClick={() => setDenied(true)}
                className="w-full rounded-xl border border-[#2D323E] py-3 text-sm font-semibold text-[#8A8F98] transition-colors hover:border-[#EF4444]/50 hover:text-[#EF4444]"
              >
                Soy menor de 18 años
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
